// extracted by mini-css-extract-plugin
module.exports = {"container":"screenSelector_container__2dtS5"};